<div>
  <label class="{{ styleClass }}">
    <span>{{ label | translate }}</span>
    @if (required) {
    <span class="required-asterisk">*</span>
    }
  </label>

  @if (multiple) {
  <p-multiSelect
    [options]="items"
    [optionLabel]="bindLabel"
    [optionValue]="bindValue"
    [placeholder]="placeholder"
    [filter]="searchable"
    [showClear]="true"
    [disabled]="disabled"
    [ngModel]="value"
    [emptyMessage]="notFoundText"
    [emptyFilterMessage]="notFoundText"
    styleClass="w-100"
    appendTo="body"
    (ngModelChange)="handleChange($event)"
    (onFilter)="onSearch($event.filter)"
    (onClear)="clearItems()"
    (onChange)="onValueChange($event.value)"
    (onPanelShow)="open.emit()"
    (onBlur)="onTouched()">
  </p-multiSelect>
  } @else {
  <p-select
    [options]="items"
    [optionLabel]="bindLabel"
    [optionValue]="bindValue"
    [placeholder]="placeholder"
    [filter]="searchable"
    [showClear]="true"
    [disabled]="disabled"
    [ngModel]="value"
    [emptyMessage]="notFoundText"
    [emptyFilterMessage]="notFoundText"
    styleClass="w-100"
    appendTo="body"
    (ngModelChange)="handleChange($event)"
    (onFilter)="onSearch($event.filter)"
    (onClear)="clearItems()"
    (onChange)="onValueChange($event.value)"
    (onShow)="open.emit()"
    (onBlur)="onTouched()">
  </p-select>
  }
</div>
